/**
 * This class represents a telephony forward.
 */
export class TelephonyForward {

    /**
     * @public
     * @property {string} type The forward type.
     *           Supported values: "immediate", "busy", "noreply"
     * @readonly
     */
    public type: string;

    /**
     * @public
     * @property {boolean} activate True if the corresponding forward for this type is activated
     */
    public activate: boolean;

    /**
     * @public
     * @property {string} destinationType The destination type of the forward (sipWise only).
     *           Supported values: "voicemail", "internalnumber", "externalnumber"
     */
    public destinationType?: string;

    /**
     * @public
     * @property {string} name The name of the forward destination (user or group's displayname)
     */
    public name?: string;

    /**
     * @public
     * @property {string} number The phone number of the forward destination
     */
    public number?: string;

    /**
     * @public
     * @property {string} userId The user identifier of the forward destination (if the destination is a user)
     */
    public userId?: string;


    constructor(type: string, activate: boolean, destinationType?: string, name?: string, number?: string, userId?: string) {
        this.type = type;
        this.activate = activate;
        this.destinationType = destinationType;
        this.name = name;
        this.number = number;
        this.userId = userId;
    }

    static createForwardFromVoiceUserData(data: any): TelephonyForward {
        return new TelephonyForward(data.type, data.activate, data.destinationType, data.name, data.number, data.userId);
    }

    static createForwardFromHybridData(hybridForwardData: { forwardType: string; pbxForwardType: string; forwardTo: string}): TelephonyForward {
        const hybridForwardType: string = hybridForwardData.forwardType;
        const hybridPbxForwardType: string = hybridForwardData.pbxForwardType;
        const hybridForwardTo: string = hybridForwardData.forwardTo;

        const activate: boolean = hybridForwardType === "Activation";

        const type: string = hybridPbxForwardType;
        const number: string = hybridForwardTo;
        const destinationType: string = (hybridForwardTo === "VOICEMAILBOX") ? "voicemail" :
            (hybridForwardTo?.startsWith("+") ? "externalnumber" : "internalnumber");

        const name: string = "";
        const userId: string = undefined;

        return new TelephonyForward(type, activate, destinationType, name, number, userId);
    }

    public updateFromVoiceEventData(activate: boolean, destinationType: string, name: string): this {
        this.activate = activate;
        this.destinationType = destinationType;
        this.name = name;
        if (!this.activate || this.destinationType === "voicemail") {
            this.number = "";
        }
        return this;
    }
}
